export const faqs = [
  {
    question: "What is Interceptive Orthodontics Blueprint™?",
    answer:
      "It's a digital educational collection covering early orthodontic assessment, mixed dentition, growth-related considerations, interceptive treatment planning, and clinical monitoring. The collection includes six specialized volumes and five complementary resources.",
  },
  {
    question: "Who is this collection designed for?",
    answer:
      "It's intended for dental professionals, orthodontic professionals, and appropriately supervised dental trainees interested in studying early orthodontic assessment and treatment-planning principles. It does not provide authorization or qualifications to perform procedures outside your professional scope.",
  },
  {
    question: "Do I need to be an orthodontic specialist?",
    answer:
      "You do not need to be an orthodontic specialist to study the educational concepts. However, using this information in clinical practice requires appropriate professional qualifications, training, supervision where applicable, and adherence to local regulations.",
  },
  {
    question: "Does this collection teach me how to perform orthodontic procedures?",
    answer:
      "The primary focus is educational clinical reasoning, assessment, and planning. It does not replace hands-on training, specialist education, supervised clinical experience, or patient-specific treatment protocols.",
  },
  {
    question: "Does it cover mixed dentition?",
    answer:
      "Yes. The collection includes a dedicated volume on mixed dentition and growth assessment, along with complementary visual reference materials.",
  },
  {
    question: "Does it include Phase I treatment planning?",
    answer:
      "Yes. You'll find educational content covering treatment objectives, indications, limitations, monitoring, and considerations relevant to early orthodontic intervention.",
  },
  {
    question: "Can I use the information with patients in different countries?",
    answer:
      "The underlying educational concepts may be relevant internationally. However, diagnostic standards, clinical guidelines, professional scope, and regulatory requirements can vary by country. Always follow applicable local requirements and current evidence-based guidance.",
  },
  {
    question: "Is this a video course?",
    answer:
      "No. It's a digital reference collection consisting of written educational volumes, visual materials, and reusable worksheets.",
  },
  {
    question: "How will I receive the materials?",
    answer:
      "The collection is delivered digitally after purchase. Your order confirmation will provide your access information.",
  },
  {
    question: "Can I download the materials?",
    answer:
      "Yes. The product is designed as a digital PDF collection. Download and access instructions are provided after purchase.",
  },
  {
    question: "Is the $27 payment recurring?",
    answer:
      "No. The advertised price is a one-time payment of $27 USD. There are no monthly subscription fees for the collection.",
  },
  {
    question: "Do I receive lifetime access?",
    answer:
      "Yes, the offer includes lifetime access to the purchased digital materials, subject to the published terms of access.",
  },
  {
    question: "Does the collection guarantee better treatment outcomes?",
    answer:
      "No. The collection is intended to support professional education and organized clinical reasoning. Clinical outcomes depend on numerous patient-specific factors, professional expertise, and appropriate treatment decisions.",
  },
  {
    question: "What if the collection isn't right for me?",
    answer:
      "The offer includes a seven-day refund policy. Please review the published refund terms and contact instructions before purchase.",
  },
];
